export default {
  "translation": {
    "card_application": "Aplicação de Cartão",
    "card_application_des": "Obtenha um cartão Sonic e use-o em mais de 44M de comerciantes habilitados pela Visa globalmente.",
    "spend_your_crypto_like_fiat": "Gaste sua criptomoeda como fiat",
    "use_globally_across_borders": "Use globalmente, além fronteiras",
    "ultra_low_trans_costs": "Custos de transação ultra baixos",
    "seamless_and_secure": "Simples e Seguro",
    "two_factor_verification": "Verificação em duas etapas",
    "two_factor_verification_des": "Faça login com segurança usando e-mail, telefone, biometria e/ou aplicativo autenticador",
    "safety_pin": "PIN de Segurança",
    "safety_pin_des": "Restrinja o acesso a informações privadas configurando um PIN",
    "trans_3ds_verification": "Verificação 3DS",
    "trans_3ds_verification_des": "Autorize compras antes de serem processadas",
    "additional_security": "Segurança Adicional",
    "additional_security_des": "Configure facilmente limites de cartão e outros recursos de segurança no aplicativo",
    "get_your_redotpay_card_in_steps": "Obtenha seu cartão Sonic em 3 etapas simples.",
    "get_your_redotpay_card_subtitle": "Gaste criptomoedas como dinheiro fiduciário: Aceito em mais de 44 milhões de comerciantes habilitados para Visa no mundo todo.",
    "continue_key": "Continuar",
    "bind_your_mobile_number": "Vincule seu número de celular",
    "complete_identity_verification": "Conclua a verificação de identidade",
    "apply_a_virtual_or_physical_card": "Solicitar um cartão virtual ou físico",
    "transactions": "Transações",
    "need_mobile_bind_confirm": "Precisa vincular o celular primeiro",
    "info": "Informação",
    "card_trans_status_refund_pending": "Reembolso Pendente",
    "card_trans_status_refund_success": "Reembolso Bem-sucedido",
    "card_trans_status_refund_fail": "Reembolso Falhou",
    "card_trans_status_refund_wait": "Reembolso Aguardando",
    "card_trans_status_pending": "Autorizado",
    "card_trans_status_cleared": "Liberado",
    "card_trans_status_declined": "Recusado",
    "card_trans_status_canceled": "Revertido",
    "card_trans_status_refund": "Reembolso",
    "card_trans_status_refund_cancel": "Reembolso Cancelado",
    "refund": "Reembolso",
    "transaction_list": "Lista de Transações",
    "more": "Mais",
    "top_questions": "Principais Perguntas",
    "faq": "FAQ",
    "self_service": "Autoatendimento",
    "support_center": "Centro de Suporte",
    "hello": "Olá",
    "updated_on": "Atualizado em",
    "chat_with_us": "Converse Conosco",
    "warning": "Aviso",
    "security_option_change_alert_prompt": "Após desvincular/modificar o Google Authenticator/celular/e-mail/PIN, saques e transferências internas serão desativados e as transações com cartão serão limitadas a $1000 por transação nas próximas 24 horas por razões de segurança.",
    "cancel": "Cancelar",
    "ok": "OK",
    "account_deletion_regret_promp": "A exclusão da conta permite um período de arrependimento de 15 dias. Quando você fizer login novamente dentro de 15 dias após solicitar a exclusão, sua solicitação será cancelada e sua conta poderá continuar a ser usada normalmente.",
    "view_on_blockchain_explorer": "Ver no explorador de blockchain",
    "biz_sn": "Número de Transação",
    "type": "Tipo",
    "create_time": "Data de Criação",
    "logout_confirm": "Tem certeza de que deseja sair?",
    "wallet": "Carteira",
    "continue_with_google": "Continuar com Google",
    "insufficient_balance_deposit_guide": "Saldo insuficiente. Deposite ativos ou suas transações serão recusadas e uma taxa poderá ser cobrada.",
    "to": "Para",
    "bill_will_be_sent_to": "A fatura será enviada para",
    "bill_statement": "Extrato da Fatura",
    "export_bill": "Exportar Extrato de Fatura",
    "this_month": "Este Mês",
    "last_month": "Mês Passado",
    "last_3_month": "Últimos 3 Meses",
    "this_year": "Este Ano",
    "last_year": "Ano Passado",
    "customize": "Personalizar",
    "bill_export_success": "O extrato da fatura foi enviado para o seu e-mail, por favor verifique",
    "bill_empty": "Sua fatura está vazia",
    "channel": "Canal",
    "merchant_country": "País do Comerciante",
    "status": "Status",
    "withdraw_detail": "Detalhes de Retirada",
    "new_key": "Novo",
    "deposit": "Depósito",
    "withdraw": "Saque",
    "single_limit": "Limite Único",
    "all": "Todos",
    "minimum": "Mínimo",
    "available": "Disponível",
    "received_amount": "Quantidade Recebida",
    "withdrawl": "Retirada",
    "network_fee": "Taxa de Rede",
    "register": "Registrar",
    "register_login": "Registrar/Login",
    "login": "Entrar",
    "email_Phone": "E-mail/Telefone",
    "email": "E-mail",
    "mobile": "Celular",
    "next": "Próximo",
    "or_continue_with": "Ou continue com",
    "forgot_pw": "Esqueceu sua senha?",
    "welcome_to_redotpay": "Bem-vindo ao Sonic Pay",
    "verify_code": "Verificar Código",
    "get_code": "Obter código",
    "by_creating_an_account": "Ao criar uma conta, você concorda com nossa",
    "privacy_policy": "política de privacidade",
    "terms_conditions": "Termos & Condições",
    "and": "e",
    "modify_pin": "Alterar PIN",
    "pin_subtitle": "O PIN de segurança oferece verificação rápida, facilitando para você visualizar números de cartão e informações CVV.",
    "password_set_first_login": "Primeiro login para definir senha",
    "next_step": "Próximo Passo",
    "confirm": "Confirmar",
    "username": "Nome de usuário",
    "password": "Senha",
    "send_code": "Enviar Código",
    "send_code_to": "O código será enviado para",
    "switch_option": "Mudar Opção de Verificação",
    "mobile_verification": "Verificação por Celular",
    "email_verification": "Verificação por E-mail",
    "choose_verify_method": "Mudar Opção de Verificação",
    "verify_pin": "PIN de Segurança",
    "google_authenticator_verification": "Google Authenticator",
    "security": "Segurança",
    "bound": "Vinculado",
    "unbound": "Desvinculado",
    "set": "Definir",
    "unset": "Não Definido",
    "update_pw": "Alterar Senha",
    "delete_account": "Excluir Conta",
    "google_authenticator": "Google Authenticator",
    "google_authenticator_subtitle": "O Google Authenticator protege seus saques e sua conta.",
    "download_install": "Baixar",
    "download_install_prompt": "Primeiro, você precisa baixar e instalar o aplicativo Authenticator (Google Authenticator)",
    "backup_key": "Chave de Backup",
    "save_backup_key": "Salve esta chave de backup em um local seguro",
    "google_authenticator_code": "Código do Google Authenticator",
    "email_subtitle": "A verificação por e-mail protege seus saques e sua conta.",
    "change_email": "Alterar E-mail",
    "email_update": "Atualizar E-mail",
    "code": "Código",
    "mobile_subtitle": "A verificação por celular protege seus saques e sua conta.",
    "change_mobile": "Alterar Celular",
    "mobile_update": "Atualizar Celular",
    "mobile_bind": "Vincular Telefone Celular",
    "email_bind": "Vincular E-mail",
    "old_password": "Senha Antiga",
    "new_password": "Nova Senha",
    "new_password_confirm": "Confirmar Nova Senha",
    "language": "Idioma",
    "appearance": "Aparência",
    "logout": "Sair",
    "log_out_toast": "Você foi desconectado",
    "set_pin": "PIN de Segurança",
    "account_deletion_prompt_1": "Esta conta nunca será recuperada",
    "account_deletion_prompt_2": "Todos os subusuários / outras contas criadas por esta conta serão excluídos e não poderão ser recuperados.",
    "account_deletion_prompt_3": "Todas as chaves de API associadas a esta conta serão excluídas.",
    "account_deletion_prompt_4": "Todos os saques de moeda delegados e pendentes desta conta serão cancelados.",
    "account_deletion_prompt_5": "Todas as funções de transação desta conta serão desativadas.",
    "account_deletion_prompt_6": "Ativos não retirados desta conta serão considerados como ativos voluntariamente abandonados.",
    "account_deletion_prompt_7": "Após solicitar a exclusão de uma conta, você terá um período de retirada de 15 dias. Quando você fizer login novamente dentro de 15 dias após a solicitação de exclusão, sua solicitação de exclusão será cancelada e a conta poderá continuar a ser usada normalmente.",
    "kyc_status_0": "Não Enviado",
    "kyc_status_1": "Verificando...",
    "kyc_status_2": "Aprovado",
    "kyc_status_3": "Auditoria Falhou",
    "kyc_status_4": "Reenviado",
    "kyc_status_5": "Submeter ao Provador",
    "personal_info_review": "Revisão de Informações Pessoais",
    "additional_info_request": "Solic",
    "verifying": "Verificando...",
    "form_submitted_will_review_asap_new": "Sua aplicação foi enviada para revisão manual. O processo geralmente leva de 3 a 5 dias, mas pode ocasionalmente demorar mais. Por favor, tenha paciência.",
    "get_verified": "Verificação de Identidade",
    "kyc_verified": "Identidade do Usuário Verificada",
    "approved": "Aprovado",
    "not_able_to_submit_identity": "Como parte do nosso processo abrangente de revisão, precisamos de informações adicionais de você para completar os procedimentos de Conheça Seu Cliente (KYC) e Anti-Lavagem de Dinheiro (AML).",
    "aml_review_failed": "Para prosseguir com sua aplicação, por favor clique no botão abaixo para acessar e completar o formulário de Autodeclaração.",
    "aml_declaration_prompt": "Por favor, note que a falha em fornecer o formulário solicitado dentro dos próximos 14 dias resultará na rejeição da sua aplicação.",
    "verify_your_identity": "Verifique sua identidade",
    "get_identity_verified": "Verifique sua identidade para comprar e usar o cartão",
    "country_region": "País/Região",
    "given_name": "Nome",
    "surname": "Sobrenome",
    "date_of_birth": "Data de Nascimento",
    "document_type": "Tipo de Documento",
    "document_number": "Número do Documento",
    "given_name_intl": "Nome(INTL)",
    "surname_intl": "Sobrenome(INTL)",
    "click_to_add_signature": "Clique para adicionar assinatura",
    "rewrite": "Reescrever",
    "submit": "Enviar",
    "save": "Salvar",
    "accounts_are_not_available": "Contas não estão disponíveis",
    "abandon_assets": "Abandonar ativos de {{amount}} {{currency}}",
    "account_deletion_successful": "Exclusão da conta bem-sucedida",
    "passwords_do_not_match": "As senhas não coincidem",
    "password_reset_success": "Redefinição de senha bem-sucedida",
    "password_confirm": "Confirmação de Senha",
    "is_refund": "Reembolso",
    "total_debt": "Total da Dívida",
    "your_account_is_in_arrears": "Sua conta está em atraso. Por favor, deposite fundos suficientes para liquidar o saldo. Sua conta/cartão será restaurada quando seu saldo for ≥10 USD após o pagamento da dívida.",
    "repayment": "Reembolso",
    "debit_record": "Registro de Débito",
    "no_data": "Dados Vazios",
    "payment": "Pagamento",
    "transaction_details": "Detalhes da Transação",
    "transaction_date": "Data da Transação",
    "transaction_id": "ID da Transação",
    "view_linked_order": "Ver Pedido Vinculado",
    "rights_interests": "Direitos e Interesses",
    "transaction_limit": "Limite de Transação",
    "deposit_withdraw": "Depósito e Retirada",
    "card_purchased_number": "Número de cartões disponíveis para compra",
    "on_review_your_applicant": "Estamos revisando sua aplicação",
    "form_en_only": "O formulário pode ser preenchido apenas em inglês",
    "available_to_spend": "Disponível para gastar",
    "get_a_card": "Obtenha um cartão Sonic e use-o em mais de 44 milhões de comerciantes habilitados para Visa em todo o mundo.",
    "virtual_card": "Cartão Virtual",
    "physical_card": "Cartão Físico",
    "apply_card": "Solicitar Cartão",
    "enjoy_seamless_spending": "Gaste",
    "spend_and_withdraw": "Gaste e saque em caixa eletrônico",
    "card_labeling": "Rotulação de Cartão",
    "card_tag": "Etiqueta do Cartão",
    "edit_billing_address": "Endereço de Cobrança",
    "government_issued_id": "Documento de Identidade Emitido pelo Governo",
    "facial_recognition": "Reconhecimento Facial",
    "address": "Endereço",
    "personnel_information_details": "Detalhes das Informações Pessoais",
    "nation_list": "Lista de Nações",
    "choose_channel": "Modo de Verificação",
    "mobile_channel_sms": "SMS",
    "mobile_channel_smsAliyunWhatsApp": "WhatsApp",
    "card_application_order": "Pedido de Aplicação de Cartão",
    "promo_code_optional": "Código Promocional (Opcional)",
    "promo_code": "Código Promocional",
    "billing_address": "Endereço de Cobrança",
    "shipping_address": "Endereço de Envio",
    "shipping_to": "Envio para",
    "card_purchase_fee": "Taxa de Compra do Cartão",
    "card_holder_name": "Nome do Titular do Cartão",
    "city": "Cidade",
    "province_state": "Província/Estado",
    "postal_code": "Código Postal/CEP",
    "address_line1": "Endereço",
    "address_line2": "Linha de Endereço 2",
    "please_fill_in_the_information_in_english": "O formulário pode ser preenchido apenas em inglês",
    "first_name": "Primeiro Nome",
    "last_name": "Último Nome",
    "country_code": "Código do País",
    "card_application_list": "Lista de Aplicações de Cartão",
    "buy_virtual_card": "Comprar Cartão Virtual",
    "buy_physical_card": "Comprar Cartão Físico",
    "withdraw_list": "Lista de Retiradas",
    "no_more_data": "Sem Mais Dados",
    "select_a_network": "Selecione uma rede",
    "please_select_network": "Por favor, selecione uma rede",
    "select_a_network_ensure": "Certifique-se de que a rede escolhida para depósito corresponda à rede de retirada, ou os ativos podem ser perdidos.",
    "network": "Rede",
    "card_management": "Gerenciamento de Cartão",
    "freeze": "Congelar",
    "unfreeze": "Descongelar",
    "freeze_card_des": "Uma vez que a função de bloqueio de cartão com uma tecla esteja ativada, você não poderá usar este cartão, mas não afetará outros cartões. Se quiser cancelar a função de bloqueio de cartão com uma tecla, você pode ativá-la novamente aqui.",
    "freezing_trades": "Congelar um cartão gera um pedido falhado, causando falha na transação ou taxas adicionais para negociações recusadas",
    "unfreeze_your_card_desc": "Uma vez que a função de desbloqueio de cartão com uma tecla esteja desativada, você poderá usar este cartão novamente, e não afetará outros cartões. Se quiser congelar o cartão, você pode fazer isso novamente aqui.",
    "card_tag_set_success": "Etiqueta do cartão definida com sucesso",
    "bill": "Conta",
    "setting": "Configuração",
    "limit": "Limite",
    "assets_list": "Lista de Ativos",
    "empty_data": "Dados Vazios",
    "deposit_list": "Lista de Depósitos",
    "date": "Data",
    "merchant_city": "Cidade do Comerciante",
    "card_number": "Número do Cartão",
    "card_type": "Tipo de Cartão",
    "mcc": "MCC",
    "declined_reason": "Razão da Recusa",
    "card_authorization_payment": "Pagamento de Autorização do Cartão",
    "declined_transaction_fee": "Taxa de Transação Recusada",
    "verified": "Verificado",
    "notifications": "Notificações",
    "need_to_add_bill_address": "É necessário adicionar um endereço de cobrança",
    "need_to_add_shipping_address": "O endereço de entrega não pode estar vazio",
    "success": "Sucesso",
    "welcome_redotpay": "Bem-vindo ao Sonic Pay!",
    "reset_pw_alert": "Após a mudança de senha, a retirada e a transferência interna serão desativadas e as transações do cartão serão limitadas a $1000 por transação nas próximas 24 horas por motivos de segurança.",
    "no_more_records": "Sem Mais Registros",
    "add": "Adicionar",
    "address_label": "Rótulo do Endereço",
    "add_address": "Adicionar Endereço",
    "this_field_is_required": "Este campo é obrigatório",
    "ID_CARD": "Carteira de Identidade",
    "PASSPORT": "Passaporte",
    "DRIVERS": "Carteira de Motorista",
    "RESIDENCE_PERMIT": "Permissão de Residência",
    "amount": "Quantidade",
    "withdraw_status_waiting": "Aguardando",
    "withdraw_status_pending": "Pendente",
    "withdraw_status_success": "Sucesso",
    "withdraw_status_fail": "Falha",
    "withdraw_status_canceled": "Cancelado",
    "withdraw_status_declined": "Recusado",
    "withdraw_status_complete": "Completo",
    "order_id": "ID do Pedido",
    "click_or_scroll_to_load_more": "Clique ou role para carregar mais",
    "minimum_deposit_amount": "Quantidade Mínima de Depósito",
    "deposit_arrival_confirmations": "Chegada do depósito: {{confirmations}} confirmações",
    "confirmations": "{{confirmations}} Confirmações",
    "deposit_network": "Rede de Depósito",
    "minimum_deposit": "Depósito Mínimo",
    "deposit_arrival": "Chegada do Depósito",
    "current_address_supports_depositing": "O endereço atual suporta apenas o depósito de {{varietyCode}} em {{displayName}}, e outros ativos serão perdidos.",
    "copy_successful": "Copia bem-sucedida",
    "update_password_successful": "Atualização da Senha Bem-sucedida",
    "update_successful": "Atualização Bem-sucedida",
    "successful": "Bem-sucedido",
    "signature_required": "Assinatura Necessária",
    "deposit_successful": "Depósito Bem-sucedido",
    "sign_out": "Sair",
    "cancel_withdraw_order_success": "Cancelamento do Pedido de Retirada Bem-sucedido",
    "delete_successful": "Exclusão Bem-sucedida",
    "unfreeze_card_successful": "Desbloqueio do Cartão Bem-sucedido",
    "card_nickname_set_success": "Apelido do Cartão Definido com Sucesso",
    "trans_limit_adjusted_success": "Limite de Transação Ajustado com Sucesso",
    "set_card_pin_success": "PIN do Cartão Definido com Sucesso",
    "withdraw_apply_commit_please_wait": "Aplicação de retirada enviada, por favor aguarde",
    "unfreeze_success": "Desbloqueio Bem-sucedido",
    "freeze_success": "Congelamento Bem-sucedido",
    "withdraw_duration_tip": "As aplicações de retirada serão processadas dentro de um dia útil",
    "you_will_withdraw": "Você irá retirar",
    "withdraw_info": "Informações de Retirada",
    "please_confirm_same_network": "Certifique-se de que a rede escolhida para depósito corresponda à rede de depósito, ou os ativos podem ser perdidos.",
    "cancel_withdraw_order_confirm": "Tem certeza de que deseja cancelar a retirada?",
    "valid_thru": "válido até",
    "last_7_days": "Últimos 7 Dias",
    "last_30_days": "Últimos 30 Dias",
    "today": "Hoje",
    "all_done": "Tudo Pronto",
    "view_details": "Ver Detalhes",
    "withdraw_success": "Retirada Bem-sucedida",
    "pay": "Pagar",
    "fee": "taxa",
    "discount": "Desconto",
    "price": "Preço",
    "card_application_details": "Detalhes da Aplicação do Cartão",
    "card_pin": "PIN do Cartão",
    "card_pin_format_helper": "Não pode conter três números idênticos consecutivos ou números sequenciais",
    "digit_variable": "{{count}} dígito",
    "address_book": "Catálogo de Endereços",
    "unlimited": "Ilimitado",
    "single": "Único",
    "update_card_pin": "Atualizar PIN do Cartão",
    "set_card_pin": "Definir PIN do Cartão",
    "report_lost": "Reportar Perdido",
    "report_lost_card": "Reportar cartão perdido",
    "card_lost_report_alert": "Após reportar perdido, o cartão será desativado e você não poderá mudar o status. Se desejar usar o cartão novamente ou solicitar um novo cartão, entre em contato com a equipe de atendimento ao cliente.",
    "pending": "Pendente",
    "frozen": "Congelado",
    "phone_number": "Número de Telefone",
    "search": "Pesquisar",
    "reset": "Redefinir",
    "total_amount": "Quantidade Total",
    "actual_amount": "Quantidade Real",
    "already_have_an_account": "Já possui uma conta?",
    "create_account": "Criar uma Conta Sonic Pay",
    "total_balance": "Saldo Total",
    "cards_balance_available_promp": "Limite de crédito calculado em tempo real com base nos ativos da carteira",
    "got_it": "Entendi",
    "review_details": "Rever Detalhes",
    "delete_this_address": "Tem certeza de que deseja excluir este endereço?",
    "currency": "Moeda",
    "merchant_name": "Nome do Comerciante",
    "request_time": "Hora do Pedido",
    "is_transaction_allowed": "Esta transação é permitida?",
    "approve": "Aprovar",
    "decline": "Recusar",
    "card_in_production": "Cartão em produção",
    "redotpay_card_sent": "Cartão Redotpay enviado",
    "redotpay_card_activated": "Cartão Redotpay ativado",
    "activate_card": "Ativar cartão",
    "paste": "Colar",
    "fees_included": "Taxas Incluídas",
    "fx_fee": "Taxa de câmbio",
    "small_auth_fee": "Taxa de transação pequena",
    "atm_fee": "Taxa de ATM",
    "received": "Recebido",
    "incremental": "Incremental",
    "bill_address_save_success": "Endereço de cobrança salvo com sucesso",
    "no_more_trans_record": "Não existem mais registos de transações",
    "withdraw_amount_larger_than_available": "Excede o saldo disponível máximo",
    "withdraw_lower_than_min": "Abaixo do valor mínimo de saque",
    "card_is_deleted": "Cartão foi excluído",
    "something_error": "Algo deu ruim",
    "home": "Casa",
    "select_country": "Selecionar País",
    "billing_list": "Lista de Faturas",
    "coupon_code": "código de cupom",
    "password_rule1": "De 8 a 32 caracteres",
    "password_rule2": "Pelo menos uma letra maiúscula em inglês",
    "password_rule3": "Pelo menos uma letra minúscula em inglês",
    "password_rule4": "Pelo menos um dígito",
    "set_pw": "Definir senha",
    "payment_currency_settings": "Configurações da moeda de pagamento",
    "customize_payment_currency": "Personalizar moeda de pagamento",
    "disable_non_local_tip": "Desativar transações em moedas não locais pode reduzir efetivamente o risco de fraude com cartões.",
    "charging_rules": "Regras de cobrança",
    "reissue_card": "Reemitir cartão",
    "update_cvv": "Atualizar CVV",
    "update_cvv_desc": "Mesmo número de cartão com novo CVV e nova data de validade.",
    "reissue_fee": "Taxa de reemissão",
    "fx_fee_desc": "A taxa de câmbio (FX) inclui uma taxa de 1,2% para transações em moedas não padrão (se aplicável).",
    "atm_fee_desc": "Será cobrada uma taxa adicional de 2% para cada retirada no caixa eletrônico.",
    "remit_fee_desc": "Taxa para o uso de cartões de crédito ou débito Visa.",
    "risk_safety_tips": "Dicas de segurança",
    "risk_safety": "Por razões de segurança, conclua a verificação facial no aplicativo antes de realizar qualquer operação relacionada.",
    "go_to_app_verify": "Ir para o aplicativo para verificar",
    "register_download_app_title": "Sonic card service is ending. If you're a Sonic cardholder, you can get a free virtual card when you switch to RedotPay.",
    "register_download_app_desc": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "get_your_free_card": "Get your free card",
    "register_download_app_title_ended": "Sonic card services have now moved to RedotPay. If you're a Sonic cardholder, you can get a free virtual card when you register with RedotPay.",
    "register_download_app_desc_ended": "Starting today, new registrations for the Sonic card, card issuance, and deposits are no longer available.\n\nFrom <bold>September 15, 2026</bold>, Sonic cards can no longer be used for transactions.\n\nWe've arranged so that you can continue your card services with RedotPay. <bold>Just register using the same email address linked to your Sonic account.</bold>\n\nIf you have a Sonic card, you'll get a free virtual RedotPay card once the move is complete.",
    "go_to_redotpay": "Go to RedotPay",
    "go_to_redotpay_now": "Ir para RedotPay agora",
    "close": "Fechar",
    "card_cancellation": "Cancelamento do cartão",
    "delete_card": "Excluir cartão",
    "delete_card_desc": "Uma vez excluído, o cartão ficará indisponível e esta ação não pode ser desfeita.",
    "deleting_fee": "Taxa de exclusão",
    "currency_tips": "Dicas sobre moedas",
    "at_least_one_currency": "Mantenha pelo menos uma moeda habilitada para pagamentos.",
    "all_select_currency": "Você já suporta transações em todas as moedas.",
    "small_auth_transaction_fee_stas": "Detalhes da taxa de transações pequenas",
    "small_transactions_this_month": "Transações pequenas neste mês",
    "small_autn_trans_remain": "Número de isenções de taxa para transações pequenas neste mês",
    "rules": "Regras",
    "failed_rules": "Transações malsucedidas aumentam o registro de transações com falhas e, se exceder o limite, serão cobradas taxas adicionais. Realize as transações de maneira adequada.",
    "rule_item": "Item",
    "free_count": "Contagem gratuita",
    "fees": "Taxas",
    "declined_trans_remain": "Número de isenções de taxa para transações recusadas neste mês",
    "declined_transaction_fee_stats": "Estatísticas de taxas de transações recusadas",
    "declined_rules": "Transações malsucedidas aumentam o registro de transações com falhas e, se exceder o limite, serão cobradas taxas adicionais. Realize as transações de maneira adequada.",
    "declined_transactions_this_month": "Transações recusadas neste mês",
    "card_trans_detail_status_refund": "Reembolso em processamento",
    "card_trans_status_reversal": "Reversão",
    "card_trans_status_fully_refund": "Processado, reembolso total",
    "card_trans_status_partial_refund": "Processado, reembolso parcial",
    "card_trans_status_void": "Nulo",
    "first_time_free": "Primeira vez grátis",
    "FxFee": "Taxa de câmbio",
    "AtmFee": "Taxa de caixa eletrônico",
    "RemitFee": "Taxa de remessa",
    "MccFee": "Taxa MCC",
    "mcc_fee_desc": "Alguns comerciantes aplicarão uma taxa adicional de 1,5% do valor da transação. Se a taxa for inferior a 0,5 USD, será aplicada uma taxa mínima de 0,5 USD.",
    "please_deposit": "Por favor, faça um depósito",
    "special_mcc_fee": "Taxa MCC especial",
    "bank_verifying": "Este reembolso está sendo analisado pelo banco…",
    "estimate_time": "Tempo estimado para recebimento: 2-30 dias",
    "delete_out": "Sair",
    "card_is_loss": "O cartão foi declarado como perdido",
    "incremental_desc": "Se o valor autorizado for insuficiente, serão cobradas taxas adicionais, e o valor correspondente será adicionado no momento da liquidação.",
    "card_trans_status_fully_refund1": "Liquidado",
    "card_trans_status_fully_refund2": "Totalmente Reembolsado",
    "card_trans_status_partial_refund1": "Liquidado",
    "card_trans_status_partial_refund2": "Parcialmente Reembolsado",
    "review_takes_time": "A revisão leva de 2 minutos a 24 horas.",
    "custom_date_null": "Por favor, selecione uma data personalizada",
    "custom_date_error": "Por favor, defina o tempo de consulta correto",
    "small_trade_fee": "Taxa de transação pequena",
    "user_risk_exception": "Exceção de status do usuário",
    "request_exception": "Erro na solicitação",
    "mobile_is_not_empty": "Por favor, insira um número de celular válido",
    "code_is_not_empty": "Por favor, insira um código de verificação válido",
    "browser_paste_error": "Restrições do navegador, introduza manualmente"
  }
};